
    document.getElementById("calculate-button").addEventListener("click", function() {
    const atBats = parseFloat(document.getElementById("atBats").value);
    const homeRuns = parseFloat(document.getElementById("homeRuns").value);
    const bodyweight = parseFloat(document.getElementById("bodyweight").value);
    const avgBodyweight = parseFloat(document.getElementById("avgBodyweight").value);

    let p4pScoreElement = document.getElementById("p4p-score");

    if (!isNaN(atBats) && !isNaN(homeRuns) && !isNaN(bodyweight) && !isNaN(avgBodyweight) && atBats > 0 && bodyweight > 0 && avgBodyweight > 0) {

    const score = ((1000 / (atBats/homeRuns))) / ((bodyweight - (avgBodyweight - bodyweight)));
    p4pScoreElement.value = `P4P Score: ${score.toFixed(3)}`;
} else {
    p4pScoreElement.value = "Please enter valid numbers.";
}
});
